module.exports = __webpack_public_path__ + "static/screenshot-zoom-5edb802f94a0c384969d6509f6882427.jpg";